import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		requests: {
			discos: {
				endpoint: 'http://descargas.lisandroaristi.com/panel/frontend/web/getdiscos',
				playload: {}
			},
			check: {
				endpoint: 'http://descargas.lisandroaristi.com/panel/frontend/web/checkcode',
				playload: {}
			},
			download: {
				endpoint: 'http://descargas.lisandroaristi.com/panel/frontend/web/downloaddisk',
				playload: {}
			}
		}
	},
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
